import * as yup from 'yup'

export const AutoFillVerificationSchema = yup.object().shape({
  street: yup.string().required('Street is required'),
  extraInfo: yup.string(),
  city: yup
    .string()
    .required('City is required')
    .matches(/^[A-Za-z\s]+$/, 'City must contain only letters'),
  county: yup
    .string()
    .required('County is required')
    .matches(/^[A-Za-z\s]+$/, 'County must contain only letters'),
  stateId: yup.mixed().required('State is required'),
  zipCode: yup.string().required('Zip Code is required'),
})
